import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dots } from '@ynap/animations';
import BEMHelper from '@ynap/bem-helper';
import Button from '../Button/Button';

const bem = new BEMHelper('SimpleAsyncButton');

class SimpleAsyncButton extends Component {
    render() {
        const { className, containerClass, copy, disabled, loading, nohover, type, ...rest } = this.props;

        const buttonModifier = [className, 'primaryButton', loading && 'animating', disabled && 'disabled', nohover && 'nohover'];
        const buttonContent = loading ? <Dots type={type} /> : copy;

        return (
            <div className={bem('asyncButtonWrapper', null, containerClass)}>
                <Button className={bem(null, null, buttonModifier)} disabled={disabled} type={type} {...rest}>
                    {buttonContent}
                </Button>
            </div>
        );
    }
}

SimpleAsyncButton.propTypes = {
    className: PropTypes.string,
    containerClass: PropTypes.string,
    loading: PropTypes.string.isRequired,
    copy: PropTypes.string,
    type: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

SimpleAsyncButton.defaultProps = {};

export default SimpleAsyncButton;
